import { alpha, PaletteOptions } from '@mui/material/styles';
import { gradients } from './gradients';
import { payment } from './payment';
import { primitives } from './primitives';
import './types';

export const paletteLight: PaletteOptions = {
  text: {
    primary: primitives.navy[800],
    secondary: primitives.navy[500],
    subtitle: primitives.navy[700],
    disabled: primitives.cream[400],
    accent: primitives.blue[400],
    highlight: primitives.blue[400],
    white: primitives.white,
  },
  success: {
    main: primitives.green[400],
  },
  error: {
    main: primitives.red[500],
  },
  background: {
    mainBodyDesktop: primitives.cream[200],
  },
  contentBlockBackground: {
    main: primitives.cream[200],
    secondary: primitives.cream[100],
  },
  chip: {
    main: primitives.cream[50],
  },
  link: {
    main: primitives.blue[400],
  },
  header: {
    menu: {
      color: primitives.navy[800],
    },
    backButton: {
      color: primitives.navy[800],
    },
  },
  button: {
    main: primitives.violet[600],
    mainHover: primitives.violet[600],
    mainDisabled: primitives.cream[400],
    contrastMainText: primitives.cream[100],
    secondary: primitives.cream[200],
    secondaryHover: primitives.cream[200],
    secondaryDisabled: primitives.cream[400],
    contrastSecondaryText: primitives.navy[800],
    contrastTextButtonText: primitives.navy[500],
    option: primitives.cream[50],
    optionBorder: primitives.cream[200],
    optionHover: primitives.blue[400],
    optionPressed: primitives.blue[400],
    optionDisabled: primitives.cream[400],
    optionIcon: primitives.blue[400],
    contrastOptionText: primitives.navy[800],
    image: primitives.cream[50],
    imageHover: primitives.blue[400],
    imageDisabled: primitives.cream[400],
    contrastImageText: primitives.navy[800],
  },
  input: {
    main: primitives.lavender[300],
    mainHover: primitives.lavender[300],
    mainFocus: primitives.blue[400],
  },
  textField: {
    borderDisabled: alpha(primitives.black, 0.05),
  },
  select: {
    mainBackground: primitives.cream[50],
  },
  checkbox: {
    border: primitives.slate[500],
    checked: primitives.blue[400],
  },
  progressBar: {
    main: alpha(primitives.black, 0.1),
    mainFilled: primitives.blue[400],
    contrastText: primitives.cream[100],
  },
  progressCircularWithValue: {
    main: alpha(primitives.black, 0.1),
    mainFilled: primitives.cyan[300],
  },
  picker: {
    mainActiveText: primitives.white,
    mainInactiveText: alpha(primitives.white, 0.5),
    mainBackgroundAccent: alpha(primitives.navy[800], 0.3),
    secondaryActiveText: primitives.navy[800],
    secondaryInactiveText: primitives.cream[400],
    secondaryBackgroundAccent: primitives.white,
  },
  modal: {
    body: primitives.cream[50],
    border: primitives.cream[200],
    backdrop: alpha(primitives.black, 0.2),
  },
  paywall: {
    cta: primitives.violet[600],
    ctaHover: primitives.violet[600],
    ctaDisabled: primitives.cream[400],
    onCta: primitives.cream[100],
    priceText: primitives.blue[400],
    ribbon: gradients.specialOfferRibbonLight,
    onRibbon: primitives.cream[100],
    card: gradients.specialOfferCardLight,
    cardBorder: primitives.orange[500],
    badge: primitives.blue[300],
  },
  upsells: {
    option: primitives.cream[50],
    optionBorder: primitives.cream[200],
    optionChecked: alpha(primitives.blue[400], 0.2),
    optionCheckedBorder: primitives.blue[400],
    radioBorder: primitives.lavender[400],
    discountBadge: primitives.green[300],
    onDiscountBadge: primitives.navy[800],
    ribbon: primitives.orange[300],
    onRibbon: primitives.navy[800],
    promoLabelText: primitives.orange[400],
    banner: gradients.upsellsBanner,
  },
  askOnboarding: {
    glows: gradients.askOnboardingGlowsLight,
  },
  glow: {
    hero: gradients.heroGlow,
    avatar: gradients.avatarGlow,
  },
  zodiacWheel: {
    glowGradient: gradients.zodiacWheelGlowLight,
    beamGradient: alpha(primitives.blue[400], 0.2),
  },
  w2aPromotion: {
    stepsRailGradient: gradients.w2aStepsRail,
  },
  payment: {
    ...payment,
    drawer: primitives.cream[50],
    errorCaption: primitives.cream[100],
    errorCaptionBorder: primitives.orange[300],
  },
};
